import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import PropTypes from 'prop-types';

import OttoIcon from './OttoIcon';

function OttoPDFPill({ onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  const { paidFlags = [] } = useSelector((state) => state.settings.company);
  const hasAIAgentAccess = paidFlags.includes('AI_AGENT');

  if (!hasAIAgentAccess) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '250px',
        right: '50px',
        zIndex: 1000,
      }}
    >
      <Button
        type="primary"
        shape="circle"
        size="large"
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: '#FFEC89',
          borderColor: '#FFEC89',
          boxShadow: '0px 4px 20px 0px #ED4C0933',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        }}
      >
        <OttoIcon isHovered={isHovered} showStars={false} />
      </Button>
    </div>
  );
}

OttoPDFPill.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default OttoPDFPill;
